<template>
    <div>
        <div class="card dashcard mb-0">
            <div class="card-body">
                <div class="form-row">
                    <div class="col col-12 col-md-6">
                        <az-periodo v-model="filtros" :sync="true" @sync="load()" />
                    </div>
                    <div class="col col-12 col-md-3">
                        <az-input
                            icon="fa fa-building fa-fw"
                            placeholder="Selecione a Unidade..."
                            type="select"
                            :optionsList="$util.unidades_com_tags(false, true)"
                            optionsData="id_unidade_operacao"
                            optionsMode="json"
                            v-model="filtros.id_unidade_operacao" />
                    </div>
                    <div class="col col-12 col-md-3">
                        <az-input
                            icon="fas fa-filter fa-fw"
                            placeholder="Todos os status..."
                            type="select"
                            :optionsList="[
                                { id: 'A', search: 'Aguardando preços' },
                            ]"
                            optionsData="id"
                            optionsMode="json"
                            v-model="filtros.status_aquisicao" />
                    </div>
                </div>
                <div class="form-row mt-2">
                    <div class="col col-12 col-md-2">
                        <az-input   
                            icon="fa-regular fa-calendar fa-fw"
                            placeholder="Data do Processo"
                            type="select"
                            :optionsList="[
                                { id: 'final', search: 'Data Finalização' }, 
                            ]"
                            optionsData="id"
                            optionsDisplay="search"
                            optionsMode="json"
                            v-model="filtros.tipo_data" />
                    </div>
                    <div class="col col-12 col-md-10">
                        <az-input 
                            icon="fa fa-search fa-fw" 
                            placeholder="Pesquisar... (Digite # + número da aquisição, ou 'O' + número da OC para pesquisar uma específica)"
                            v-model="filtros.search"
                            @onEnter="load()">
                            <template v-slot:buttonposb>
                                <div class="input-group-append">
                                    <button class="btn btn-outline-primary" type="button" id="button-addon2" @click="incluir()">
                                        <i class="fa fa-plus" aria-hidden="true"></i>
                                    </button>
                                </div>
                            </template>
                        </az-input>
                    </div>
                </div>
            </div>
        </div>

        <div class="progress mt-1 mb-3">
            <div class="indeterminate" v-if="$store.state.loading && dados"></div>
            <div class="determinate" v-else></div>
        </div>        

        <az-empty-state v-if="!lista || !lista.length" icon="fas fa-search-dollar" msg="Nenhuma aquisição identificada." />

        <template v-else>
            <div class="card carde mb-2 w3-animate-opacity" v-for="(aqs, inx) in lista" :key="inx">
                <div class="card-body py-3">
                    <div class="row">
                        <div class="col col-12 col-md-2">
                            <button type="button" class="btn btn-sm btn-outline-primary mr-1 mb-1" @click="editar(aqs)">
                                <i class="fas fa-edit fa-fw"></i>
                            </button>
                            <button type="button" class="btn btn-sm btn-outline-success mr-1 mb-1" @click="share(aqs)">
                                <i class="fas fa-share-square"></i>
                            </button>
                            <button type="button" class="btn btn-sm btn-outline-success mr-1 mb-1" @click="editar_precos(aqs)">
                                <i class="fas fa-dollar-sign fa-fw"></i>
                            </button>
                            <template v-if="aqs.tem_precos">
                                <button type="button" class="btn btn-sm btn-outline-success mr-1 mb-1" @click="comparacao(aqs)">
                                    <i class="fa fa-table fa-fw" aria-hidden="true"></i>
                                </button>
                                <template v-if="aqs.tem_precos_selecionados">
                                    <button type="button" class="btn btn-sm btn-outline-success mr-1 mb-1" @click="ordem_de_compra(aqs)">
                                        <i class="fas fa-cart-plus fa-fw"></i>
                                    </button>
                                </template>
                                <template v-if="aqs.ocs && aqs.ocs.length">
                                    <button type="button" class="btn btn-sm mr-1 mb-1" :class="'btn-' + aqs.oc_color" @click="view_ocs(aqs)">
                                        OC
                                    </button>
                                </template>
                            </template>
                            <template v-if="aqs.list_log_integracaos_count > 0">
                                <button type="button" class="btn btn-outline-dark btn-sm mr-1 mb-1" @click="ver_log_int(aqs)" title="Log de Integração">
                                    <i class="fa-solid fa-satellite-dish"></i>
                                </button>
                            </template>
                        </div>
                        <div class="col col-12 col-md-4">
                            <div>
                                <i class="fa-regular fa-calendar-plus fa-fw mr-2"></i>
                                <span>
                                    {{ $util.getFormatDate(aqs.created_at) }}
                                </span>
                                <span class="ml-2">
                                    #{{ aqs.id_aquisicao }}
                                    <span v-if="aqs.unidade_operacao" class="badge badge-light ml-2">
                                        {{ aqs.unidade_operacao.st_sigla }}
                                    </span>
                                </span>
                            </div>
                            <div v-if="aqs.dt_fim_processo" title="Data de Finalização do Processo">
                                <i class="fa-solid fa-hourglass-end fa-fw mr-2"></i>
                                {{ $util.getFormatDate(aqs.dt_fim_processo) }}
                            </div>
                            <div class="small">
                                {{ aqs.st_observacao }}
                            </div>
                        </div>
                        <div class="col col-12 col-md-6">
                            <div class="small2">
                                <span class="badge badge-secondary mr-2" v-if="aqs.st_tipo != 'S'">{{ aqs.items.length }}</span>
                                {{ aqs.lista_items }}
                            </div>
                            <div class="small2">
                                <span class="badge badge-secondary mr-2">{{ aqs.fornecedores.length }}</span>
                                {{ aqs.lista_fornecedores }}
                            </div>
                        </div>
                    </div>
                </div>
            </div> 

            <pre class="mt-3 alert alert-info" v-if="false">{{ dados }}</pre>
        </template>

        <!-- Modal de Aquisição -->
        <div class="modal fade" id="aquisicaoModal" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
            <div class="modal-dialog modal-xl modal-dialog-scrollable" role="document">
                <div class="modal-content" v-if="item">
                    <div class="modal-header">
                        <h5 class="modal-title">
                            Aquisição <span>{{ item.id_aquisicao ? '#' + item.id_aquisicao : 'Nova' }}</span>
                        </h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div class="form-row">
                            <div class="col col-12 col-md-6">
                                <az-input
                                    sizing="sm"
                                    label="Unidade"
                                    type="select"
                                    placeholder="Selecione..."
                                    :optionsList="$util.unidades_com_tags(false, true)"
                                    optionsData="id_unidade_operacao"
                                    required
                                    :validate="validate"
                                    v-model="item.id_unidade_operacao">
                                </az-input>
                            </div>
                            <div class="col col-12 col-md-3">
                                <az-input
                                    sizing="sm"
                                    label="Tipo"
                                    type="select"
                                    placeholder="Selecione..."
                                    :optionsList="[
                                        { id: 'M', search: 'Material' },
                                        { id: 'S', search: 'Serviço' },
                                    ]"
                                    optionsData="id"
                                    required
                                    :validate="validate"
                                    v-model="item.st_tipo">
                                </az-input>
                            </div>
                            <div class="col col-12 col-md-3">
                                <az-input
                                    sizing="sm"
                                    label="Finalização do Processo"
                                    type="date"
                                    v-model="item.dt_fim_processo" />
                            </div>
                        </div>
                        <div class="form-row" v-if="item.st_tipo != 'S'">
                            <div class="col col-12 col-md-6">
                                <az-input
                                    sizing="sm"
                                    label="Gestão de Estoque"
                                    type="select"
                                    placeholder="Selecione..."
                                    service="estoque_grupo_locals.index"
                                    optionsMode="aql"
                                    optionsData="id_estoque_grupo_local"
                                    required
                                    :validate="validate"
                                    v-model="item.id_estoque_grupo_local">
                                </az-input> 
                            </div>
                        </div>
                        <div class="form-row">
                            <div class="col col-12">
                                <az-input
                                    sizing="sm"
                                    label="Observação"
                                    v-model="item.st_observacao" />
                            </div>
                        </div>

                        <ul class="nav nav-tabs mt-3" id="myTab" role="tablist">
                            <li class="nav-item" role="presentation">
                                <a class="nav-link active" id="itens-tab" data-toggle="tab" href="#itens" role="tab" aria-controls="itens" aria-selected="true">
                                    <span v-if="item.st_tipo == 'S'">
                                        Descrição
                                    </span>
                                    <span v-else>
                                        Itens
                                        <span class="badge badge-secondary">{{ item.items.length }}</span>
                                    </span>
                                </a>
                            </li>
                            <li class="nav-item" role="presentation">
                                <a class="nav-link" id="fornec-tab" data-toggle="tab" href="#fornec" role="tab" aria-controls="fornec" aria-selected="false">
                                    Fornecedores
                                    <span class="badge badge-secondary">{{ item.fornecedores.length }}</span>
                                </a>
                            </li>
                        </ul>

                        <div class="tab-content" id="myTabContent">
                            
                            <!-- ITENS -->
                            <div class="tab-pane fade show active" id="itens" role="tabpanel" aria-labelledby="itens-tab">

                                <div class="mt-3" v-if="item.st_tipo == 'M'">

                                    <template v-for="(aqitem, iaix) in lista_ativos(item.items)">
                                        <div class="form-row" :key="iaix" v-if="true">
                                            <div class="col col-12 col-md-6">
                                                <az-input
                                                    v-if="aqitem.estoque_item"
                                                    sizing="sm"
                                                    :label="iaix ? '' : 'Descrição'"
                                                    :edicao="false"
                                                    v-model="aqitem.estoque_item.search">
                                                    <template v-slot:button-pre>
                                                        <div class="input-group-append">
                                                            <button class="btn btn-outline-danger" type="button" id="button-addon2" @click="remover(aqitem)">
                                                                <i class="fa fa-minus fa-fw" aria-hidden="true"></i>
                                                            </button>
                                                        </div>
                                                    </template>
                                                </az-input>

                                                <az-input
                                                    v-else
                                                    sizing="sm"
                                                    :label="iaix ? '' : 'Descrição'"
                                                    :edicao="false"
                                                    v-model="aqitem.search">
                                                    <template v-slot:button-pre>
                                                        <div class="input-group-append">
                                                            <button class="btn btn-outline-danger" type="button" id="button-addon2" @click="remover(aqitem)">
                                                                <i class="fa fa-minus fa-fw" aria-hidden="true"></i>
                                                            </button>
                                                        </div>
                                                    </template>
                                                </az-input>
                                            </div>
                                            <div class="col col-12 col-md-3">
                                                <az-input
                                                    sizing="sm"
                                                    :label="iaix ? '' : 'Qtde'"
                                                    required
                                                    :validate="validate"
                                                    v-model="aqitem.dc_quantidade">
                                                    <template v-slot:buttonposb>
                                                        <div class="input-group-prepend" v-if="aqitem.st_unidade">
                                                            <span class="input-group-text" id="basic-addon2">
                                                                {{ aqitem.st_unidade }}
                                                                <span v-if="aqitem.in_fator != 1" class="badge badge-secondary ml-1">
                                                                    {{ aqitem.in_fator }}
                                                                </span>
                                                            </span>
                                                        </div>
                                                    </template>
                                                </az-input>
                                            </div>
                                            <div class="col col-12 col-md-3">
                                                <az-input
                                                    sizing="sm"
                                                    :label="iaix ? '' : 'Observação'"
                                                    v-model="aqitem.st_observacao" />
                                            </div>
                                        </div>
                                        <div class="small text-muted ml-3 mb-2" v-if="aqitem.estoque_item && aqitem.estoque_item.st_orientacao_compra" :key="iaix + 'or'">
                                            {{ aqitem.estoque_item.st_orientacao_compra }}
                                        </div>
                                    </template>

                                    <div class="form-row">
                                        <div class="col col-12">
                                            <selecao-material @selecionado="incluir_item" :infoqt="true" :oc="true" />
                                        </div>
                                    </div>

                                    <br><br><br><br><br>
                                </div>    

                                <div class="mt-3" v-else-if="item.st_tipo == 'S'">    

                                    <template v-for="(aqitem, iaix) in lista_ativos(item.items)">
                                        <div class="form-row" :key="iaix" v-if="true">
                                            <div class="col col-12 col-md-1">
                                                <az-input
                                                    sizing="sm"
                                                    :label="iaix ? '' : 'Qtde'"
                                                    type="number"
                                                    required
                                                    :validate="validate"
                                                    v-model="aqitem.dc_quantidade">
                                                    <template v-slot:button-pre>
                                                        <div class="input-group-prepend">
                                                            <button class="btn btn-outline-danger" type="button" id="button-addon2" @click="remover(aqitem)">
                                                                <i class="fa fa-minus" aria-hidden="true"></i>
                                                            </button>
                                                        </div>
                                                    </template>
                                                </az-input>
                                            </div>
                                            <div class="col col-12 col-md-8">
                                                <az-input
                                                    sizing="sm"
                                                    type="textarea"
                                                    rows="3"
                                                    :label="iaix ? '' : 'Descrição'"
                                                    v-model="aqitem.st_descricao">
                                                </az-input>
                                            </div>
                                            <div class="col col-12 col-md-3">
                                                <az-input
                                                    sizing="sm"
                                                    :label="iaix ? '' : 'Observação'"
                                                    v-model="aqitem.st_observacao" />
                                            </div>
                                        </div>
                                    </template>

                                    <button type="button" class="btn btn-primary btn-sm" @click="incluir_item_servico()">
                                        <i class="fa fa-plus" aria-hidden="true"></i>
                                    </button>
                                </div>

                            </div>

                            <!-- FORNECEDORES -->
                            <div class="tab-pane fade" id="fornec" role="tabpanel" aria-labelledby="fornec-tab">

                                <div class="my-3">
                                    <div class="form-row" v-for="(fornec, ifx) in lista_ativos(item.fornecedores)" :key="ifx">
                                        <div class="col col-12 col-md-6">
                                            <az-input
                                                sizing="sm"
                                                :label="ifx ? '' : 'Nome'"
                                                :edicao="false"
                                                v-model="fornec.fornecedor.search">
                                                <template v-slot:button-pre>
                                                    <div class="input-group-append">
                                                        <button class="btn btn-outline-danger" type="button" id="button-addon2" @click="remover(fornec)">
                                                            <i class="fa fa-minus fa-fw" aria-hidden="true"></i>
                                                        </button>
                                                    </div>
                                                </template>
                                            </az-input>
                                        </div>
                                        <div class="col col-12 col-md-6">
                                            <az-input
                                                sizing="sm"
                                                :label="ifx ? '' : 'Observação'"
                                                v-model="fornec.st_observacao">
                                                <template v-slot:buttonposb>
                                                    <div class="input-group-append" v-if="fornec.id_aquisicao_fornecedor">
                                                        <button class="btn btn-outline-secondary" type="button" id="button-addon2"
                                                            @click="imprimir_cotacao(fornec)">
                                                            <i class="fa fa-print" aria-hidden="true"></i>
                                                        </button>
                                                    </div>
                                                </template>
                                            </az-input>
                                        </div>
                                    </div>
                                </div>

                                <table class="table table-sm border-0 table-responsive" v-if="options_classes && options_classes.length">
                                    <tr>
                                        <td class="text-nowrap">
                                            <a href="#" @click.prevent="$refs.selforn.filtrar(classe, true)" v-for="(classe, icx) in options_classes" :key="icx">
                                                <span class="badge badge-success mr-1" >
                                                    {{ classe }}
                                                </span>
                                            </a>
                                        </td>
                                    </tr>
                                </table>

                                <div class="form-row">
                                    <div class="col col-12">
                                        <selecao-fornecedor 
                                            :parms="{ aquisicao: 1 }"
                                            oname=".aquisicao"
                                            ref="selforn" 
                                            @selecionado="incluir_fornecedor" />
                                    </div>
                                </div>

                                <br><br><br><br><br>
                                
                            </div>

                        </div>

                        <pre v-if="false">{{ item }}</pre>
                    </div>
                    <div class="modal-footer">
                        <az-audit-log-button v-if="item" model="aquisicao" :id="item.id_aquisicao" />
                        <span class="btn-group dropup">
                            <button class="btn btn-primary dropdown-toggle" type="button" id="dropdownMenuButton" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                                Clonar
                            </button>
                            <div class="dropdown-menu" aria-labelledby="dropdownMenuButton">
                                <a class="dropdown-item" href="#" @click.prevent="clonar(false)">Sem Cotações</a>
                                <a class="dropdown-item" href="#" @click.prevent="clonar(true)">Com Cotações</a>
                            </div>
                        </span>
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Fechar</button>
                        <az-submit @click="atualizar()">{{ item.id_aquisicao ? 'Atualizar' : 'Incluir' }}</az-submit>
                    </div>
                </div>
            </div>
        </div>

        <!-- Modal de Preços -->
        <div class="modal fade" id="precosModal" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
            <div class="modal-dialog modal-dialog-total modal-dialog-scrollable" role="document">
                <div class="modal-content modal-content-total" v-if="aqp">
                    <div class="modal-header">
                        <h5 class="modal-title">Preços #{{ aqp.id_aquisicao }}</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">

                        <template v-if="!precos">

                            <az-empty-state />

                        </template>

                        <template v-else>
                            <az-input 
                                v-if="precos"
                                type="select"
                                label="Fornecedor"
                                :optionsList="precos.fornecedores.map(item => { 
                                    item.search = item.fornecedor.search;
                                    return item;
                                })"
                                v-model="preco_fornecedor"
                                @input="trocar" />

                            <template v-if="preco_fornecedor && !trocando">

                                <div class="alert alert-warning my-3" v-if="preco_fornecedor && preco_fornecedor.fornecedor && preco_fornecedor.fornecedor.dc_valor_minimo">
                                    Valor mínimo do fornecedor: {{ $util.formatMoeda(preco_fornecedor.fornecedor.dc_valor_minimo) }}
                                </div>

                                <ul class="nav nav-tabs mt-3" id="myTab" role="tablist">
                                    <li class="nav-item" role="presentation">
                                        <a class="nav-link active" id="items-tab" data-toggle="tab" href="#items" role="tab" aria-controls="items" aria-selected="true">Preços</a>
                                    </li>
                                    <li class="nav-item" role="presentation">
                                        <a class="nav-link" id="cond-tab" data-toggle="tab" href="#cond" role="tab" aria-controls="cond" aria-selected="false">Condições Gerais</a>
                                    </li>
                                </ul>

                                <div class="tab-content" id="myTabContent">
                                    <!-- Itens -->
                                    <div class="tab-pane fade show active" id="items" role="tabpanel" aria-labelledby="items-tab">

                                        <pre v-if="false">{{ preco_fornecedor }}</pre>

                                        <table class="table mt-3">
                                            <thead>
                                                <tr>
                                                    <th>Descrição</th>
                                                    <th>Qtd</th>
                                                    <th>Preço</th>
                                                    <th v-if="aqp.st_tipo != 'S'">IPI</th>
                                                    <th class="text-right">Total</th>
                                                    <th v-if="false">Prazo</th>
                                                    <th>Obs</th>
                                                    <th>OC</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr v-for="(item_preco, ipx) in preco_fornecedor.precos" :key="ipx">
                                                    <td :width="aqp.st_tipo != 'S' ? '37%' : '50%'">
                                                        {{ item_preco.search }}
                                                        <span class="badge badge-secondary">
                                                            #{{ item_preco.id_estoque_item }}
                                                        </span>
                                                        <template v-if="aqp.st_tipo != 'S'">
                                                            <i class="fa fa-caret-right mx-1" aria-hidden="true"></i>
                                                            <small class="text-muted ml-1">{{ item_preco.unidade_medida }}</small>
                                                        </template>
                                                    </td>
                                                    <td width="10%">
                                                        <az-input
                                                            type="number"
                                                            sizing="sm"
                                                            :edicao="pode_editar_preco(item_preco)"
                                                            v-model="item_preco.dc_quantidade" />
                                                    </td>
                                                    <td width="15%">
                                                        <az-input
                                                            type="money"
                                                            sizing="sm"
                                                            :precision="6"
                                                            :edicao="pode_editar_preco(item_preco)"
                                                            v-model="item_preco.dc_preco" />
                                                    </td>
                                                    <td width="13%" v-if="aqp.st_tipo != 'S'">
                                                        <az-input
                                                            type="money"
                                                            sizing="sm"
                                                            :edicao="pode_editar_preco(item_preco)"
                                                            v-model="item_preco.dc_ipi" />
                                                    </td>
                                                    <td width="10%" class="text-right">
                                                        {{ 
                                                            $util.formatMoeda(
                                                                parseFloat(item_preco.dc_quantidade) * 
                                                                ( 
                                                                    parseFloat(item_preco.dc_preco) + 
                                                                    parseFloat(item_preco.dc_ipi) 
                                                                ) 
                                                            )
                                                        }}    
                                                    </td>
                                                    <td width="15%">
                                                        <az-input
                                                            sizing="sm"
                                                            :edicao="pode_editar_preco(item_preco)"
                                                            v-model="item_preco.st_observacao" />
                                                    </td>
                                                    <td>
                                                        <span class="badge" :class="'badge-' + item_preco.oc_item.oc.status_aprovacao.color" v-if="item_preco.oc_item && item_preco.oc_item.oc && item_preco.oc_item.oc.status_aprovacao"
                                                            :title="item_preco.oc_item.oc.status_aprovacao.title" 
                                                            data-toggle="tooltip">
                                                            #{{ item_preco.oc_item.id_aquisicao_ordem_compra }}
                                                        </span>
                                                    </td>
                                                </tr>
                                            </tbody>
                                            <tfoot>
                                                <tr>
                                                    <th colspan="4">Total</th>
                                                    <th class="text-right">{{ $util.formatMoeda(totalizar_lista_precos(preco_fornecedor.precos)) }}</th>
                                                </tr>
                                            </tfoot>
                                        </table>
                                        
                                    </div>

                                    <!-- Condições Gerais -->
                                    <div class="tab-pane fade" id="cond" role="tabpanel" aria-labelledby="cond-tab">

                                        <div class="mt-3">

                                            <div class="form-row">
                                                <div class="col col-12 col-md-3">
                                                    <az-input
                                                        sizing="sm"
                                                        type="date"
                                                        label="Validade da Proposta"
                                                        :validate="validate"
                                                        v-model="preco_fornecedor.dt_validade" />
                                                </div>
                                                <!--
                                                <div class="col col-12 col-md-2" v-if="false">
                                                    <az-input
                                                        sizing="sm"
                                                        type="number"
                                                        label="Número de Parcelas"
                                                        required
                                                        :validate="validate"
                                                        v-model="preco_fornecedor.in_parcelas" />
                                                </div>
                                                -->
                                                <div class="col col-12 col-md-4">
                                                    <az-input
                                                        sizing="sm"
                                                        :label="aqp.st_tipo == 'S' ? 'Prazo' : 'Prazo de Entrega'"
                                                        :validate="validate"
                                                        v-model="preco_fornecedor.st_tipo_prazo_entrega" />
                                                </div>
                                                <div class="col col-12 col-md-2">
                                                    <az-input
                                                        sizing="sm"
                                                        label="Frete"
                                                        type="select"
                                                        placeholder="Selecione..."
                                                        :optionsList="[
                                                            { id: 'N', search: 'Nenhum' },
                                                            { id: 'CIF', search: 'CIF' },
                                                            { id: 'FOB', search: 'FOB' },
                                                        ]"
                                                        v-if="aqp.st_tipo != 'S'"
                                                        optionsData="id"
                                                        optionsDisplay="search"
                                                        required
                                                        :validate="validate"
                                                        v-model="preco_fornecedor.st_tipo_frete" />
                                                </div>
                                                <div class="col col-12 col-md-3">
                                                    <az-input
                                                        sizing="sm"
                                                        label="Valor do Frete"
                                                        type="money"
                                                        required
                                                        :validate="validate"
                                                        v-if="preco_fornecedor.st_tipo_frete == 'FOB'"
                                                        v-model="preco_fornecedor.dc_valor_frete" />
                                                </div>
                                            </div>
                                        </div>

                                        <template v-if="preco_fornecedor.js_condicoes_pagamento && preco_fornecedor.js_condicoes_pagamento.parcelas">

                                            <div class="form-row" v-for="(parcela, ipx) in preco_fornecedor.js_condicoes_pagamento.parcelas" :key="ipx">
                                                <div class="col col-12 col-md-3">
                                                    <az-input
                                                        sizing="sm"
                                                        type="select"
                                                        :label="ipx ? '' : 'Regra'" 
                                                        placeholder="Selecione..."
                                                        :optionsList="[
                                                            { id: 'A', search: 'Adiantamento' },
                                                            { id: 'V', search: 'A Vista' },
                                                            { id: 'P', search: 'A Prazo' },
                                                        ]"
                                                        optionsData="id"
                                                        v-model="parcela.regra">
                                                        <template v-slot:button-pre>
                                                            <div class="input-group-prepend">
                                                                <button class="btn btn-outline-danger" type="button" id="button-addon1" @click="remover_item(preco_fornecedor, ipx)">
                                                                    <i class="fa fa-minus fa-fw" aria-hidden="true"></i>
                                                                </button>
                                                            </div>
                                                        </template>
                                                    </az-input>
                                                </div>
                                                <div class="col col-12 col-md-2">
                                                    <az-input
                                                        sizing="sm"
                                                        type="select"
                                                        :label="ipx ? '' : 'Definição'" 
                                                        placeholder="Selecione..."
                                                        :optionsList="[
                                                            { id: 'P', search: 'Percentual' },
                                                            { id: 'V', search: 'Valor' },
                                                        ]"
                                                        optionsData="id"
                                                        v-model="parcela.modo_valor" />
                                                </div>
                                                <div class="col col-12 col-md-3">
                                                    <az-input
                                                        sizing="sm"
                                                        type="money"
                                                        :label="ipx ? '' : ( parcela.modo_valor == 'P' ? 'Percentual' : 'Valor' )" 
                                                        :edicao="parcela.modo_valor ? true : false"
                                                        v-model="parcela.valor">
                                                        <template v-slot:button-pre>
                                                            <div class="input-group-prepend">
                                                                <span class="input-group-text" id="basic-addon1">
                                                                    {{ parcela.modo_valor == 'P' ? '%' : 'R$' }}
                                                                </span>
                                                            </div>
                                                        </template>
                                                    </az-input>
                                                </div>
                                                <template v-if="parcela.regra == 'P'">
                                                    <div class="col col-12 col-md-2">
                                                        <az-input
                                                            sizing="sm"
                                                            type="select"
                                                            :label="ipx ? '' : 'Referência'" 
                                                            placeholder="Selecione..."
                                                            :optionsList="[
                                                                { id: 'T', search: 'Dias' },
                                                                { id: 'D', search: 'Data' },
                                                            ]"
                                                            optionsData="id"
                                                            v-model="parcela.modo_tempo" />
                                                    </div>
                                                    <div class="col col-12 col-md-2">
                                                        <az-input
                                                            sizing="sm"
                                                            type="number"
                                                            :label="ipx ? '' : 'Dias'" 
                                                            v-if="parcela.modo_tempo == 'T'"
                                                            v-model="parcela.tempo_dias" />

                                                        <az-input
                                                            sizing="sm"
                                                            type="date"
                                                            :label="ipx ? '' : 'Data'" 
                                                            v-if="parcela.modo_tempo == 'D'"
                                                            v-model="parcela.tempo_data" />
                                                    </div>
                                                </template>

                                                <template v-else>
                                                    <div class="col col-12 col-md-2">
                                                        <az-input
                                                            sizing="sm"
                                                            type="date"
                                                            :label="ipx ? '' : 'Data'" 
                                                            v-model="parcela.tempo_data" />
                                                    </div>
                                                </template>
                                            </div>

                                        </template>

                                        <button type="button" class="btn btn-primary btn-sm mt-3" @click="incluir_parcela()">
                                            <i class="fa fa-plus mr-2" aria-hidden="true"></i>
                                            Incluir Forma de Pagamento
                                        </button>

                                    </div>
                                </div>

                            </template>

                        </template>

                        <pre class="mt-3 alert alert-warning" v-if="false">{{ precos }}</pre>

                        <pre v-if="false">{{ preco_fornecedor }}</pre>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Fechar</button>
                        <az-submit @click="atualizar_precos()">Atualizar</az-submit>
                    </div>
                </div>
            </div>
        </div>

        <!-- Modal de Seleção de Preços de Fornecedores com Comparação -->
        <div class="modal fade" id="tabelaModal" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
            <div class="modal-dialog modal-dialog-total modal-dialog-scrollable" role="document">
                <div class="modal-content modal-content-total">
                    <div class="modal-header">
                        <h5 class="modal-title">Comparação #{{ tabela ? tabela.id_aquisicao : '' }}</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <template v-if="tabela">
                            <print-export printid="print_mapa" />

                            <div id="print_mapa">
                                <div class="d-none d-print-block">
                                    <cabecalho-generico titulo="Mapa de Cotação">
                                        <div>#{{ tabela.id_aquisicao }}</div>
                                        <div>Data: {{ $util.getFormatDate(tabela.created_at) }}</div>
                                    </cabecalho-generico>
                                </div>

                                <mapa-de-cotacao :tabela="tabela" />
                            </div>
                            
                        </template>
                        <template v-else>
                            <az-empty-state />
                        </template>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Fechar</button>
                        <az-submit @click="atualizar_selecao()">Atualizar</az-submit>
                    </div>
                </div>
            </div>
        </div>

        <!-- Modal de Detalhe de Condições -->
        <div class="modal fade" id="condicoesModal" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
            <div class="modal-dialog" role="document">
                <div class="modal-content" v-if="condicoes">
                    <div class="modal-header">
                        <h5 class="modal-title">Detalhe Condições</h5>
                        <button type="button" class="close" @click="fechar('condicoesModal')" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <span v-html="condicoes.detalhe_condicoes"></span>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" @click="fechar('condicoesModal')">Fechar</button>
                    </div>
                </div>
            </div>
        </div>

        <!-- Modal -->
        <div class="modal fade" id="ordemModal" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
            <div class="modal-dialog modal-dialog-total modal-dialog-scrollable" role="document">
                <div class="modal-content modal-content-total">
                    <div class="modal-header">
                        <h5 class="modal-title">Ordem de Compra</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <template v-if="!oc_fornecedores">
                            <az-empty-state />
                        </template>

                        <template v-else>
                            <az-input 
                                type="select"
                                label="Fornecedor"
                                :optionsList="oc_fornecedores.fornecedores.map(item => { 
                                    item.search = item.fornecedor.search;
                                    return item;
                                })"
                                v-model="oc_fornecedor"
                                @input="trocar" />

                            <template v-if="oc_fornecedor">

                                <div v-if="ocs_para_adicao.length" class="mt-2">
                                    <az-input 
                                        type="select"
                                        label="Ordem de Compra"
                                        placeholder="Nova..."
                                        :optionsList="ocs_para_adicao"
                                        optionsData="id"
                                        v-model="oc_fornecedor.destino_oc_id" />
                                </div>

                                <template v-if="!oc_fornecedor.destino_oc_id">

                                    <div class="alert alert-info mt-3 d-flex justify-content-between">
                                        <div>
                                            <div class="small text-muted">Condições:</div>
                                            <span v-html="oc_fornecedor.detalhe_condicoes"></span>
                                        </div>
                                        <div v-if="oc_fornecedor.st_tipo_prazo_entrega">
                                            <div class="small text-muted">Prazo de Entrega:</div>
                                            <span v-html="oc_fornecedor.st_tipo_prazo_entrega"></span>
                                        </div>
                                        <div v-if="oc_fornecedor.st_tipo_frete == 'FOB' && oc_fornecedor.dc_valor_frete > 0">
                                            <div class="small text-muted">Frete:</div>
                                            {{ $util.formatMoeda(oc_fornecedor.dc_valor_frete) }}
                                        </div>
                                        <div v-if="oc_fornecedor.dt_validade">
                                            <div class="small text-muted">Validade:</div>
                                            <div>{{ $util.getFormatDate(oc_fornecedor.dt_validade) }}</div>
                                            <div class="small">
                                                {{ $util.getHumanDuration(oc_fornecedor.dt_validade) }}
                                            </div>
                                        </div>
                                        <div class="text-right">
                                            <button type="button" class="btn btn-sm btn-outline-primary" @click="editar_condicoes(oc_fornecedor)">
                                                <i class="fas fa-edit"></i>
                                            </button>
                                        </div>
                                    </div>

                                    <div class="form-row">
                                        <div class="col col-12">
                                            <az-input
                                                sizing="sm"
                                                type="checkbox-group"
                                                label="Definir endereço de entrega"
                                                v-model="oc_fornecedor.fl_endereco_entrega" />
                                        </div>
                                    </div>

                                    <div class="form-row" v-if="oc_fornecedor.fl_endereco_entrega">
                                        <div class="col col-12">
                                            <az-input
                                                type="textarea"
                                                rows="2"
                                                label="Endereço de Entrega"
                                                v-model="oc_fornecedor.st_endereco_entrega" />
                                        </div>
                                    </div>

                                    <div class="form-row">
                                        <div class="col col-12 col-md-6">
                                            <az-input   
                                                type="textarea"
                                                rows="2"
                                                label="Observação (Para o Fornecedor na Ordem de Compra)"
                                                v-model="oc_fornecedor.st_observacao_externa" />
                                        </div>
                                        <div class="col col-12 col-md-6">
                                            <az-input   
                                                type="textarea"
                                                rows="2"
                                                label="Observação (Interna)"
                                                v-model="oc_fornecedor.st_observacao_interna" />
                                        </div>
                                    </div>

                                    <div v-if="oc_fornecedor.fornecedor.dc_valor_minimo && totalizar_lista_precos(oc_fornecedor.sel_precos) < oc_fornecedor.fornecedor.dc_valor_minimo"
                                        class="alert alert-danger my-3">
                                        <i class="fas fa-exclamation-triangle text-danger mr-3"></i>
                                        Valor mínimo do fornecedor não atingido: {{ $util.formatMoeda(oc_fornecedor.fornecedor.dc_valor_minimo) }}
                                    </div>

                                </template>

                                <table class="table mt-3">
                                    <thead>
                                        <tr>
                                            <th>Descrição</th>
                                            <th class="text-right">Preço</th>
                                            <th class="text-right">IPI</th>
                                            <th class="text-right">Qtde</th>
                                            <th class="text-right">Total</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="(preco, ipx) in oc_fornecedor.sel_precos" :key="ipx">
                                            <td>
                                                {{ preco.item.search }}
                                                <span class="badge badge-secondary">#{{ preco.item.id_estoque_item }}</span>
                                            </td>
                                            <td class="text-right">{{ $util.formatMoeda(preco.dc_preco, 6) }}</td>
                                            <td class="text-right">{{ $util.formatMoeda(preco.dc_ipi) }}</td>
                                            <td class="text-right">{{ parseInt(preco.dc_quantidade) }}</td>
                                            <td class="text-right">{{ $util.formatMoeda((parseFloat(preco.dc_preco) + parseFloat(preco.dc_ipi)) * parseFloat(preco.dc_quantidade)) }}</td>
                                        </tr>
                                    </tbody>   
                                    <tfoot>
                                        <tr>
                                            <th colspan="4">Total</th>
                                            <th class="text-right">{{ $util.formatMoeda(totalizar_lista_precos(oc_fornecedor.sel_precos)) }}</th>
                                        </tr>
                                    </tfoot>                            
                                </table>

                            </template>

                            <pre class="alert alert-warning" v-if="false">{{ oc_fornecedor }}</pre>
                        </template>

                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Fechar</button>
                        <az-submit v-if="oc_fornecedor && oc_fornecedor.sel_precos && oc_fornecedor.sel_precos.length"
                            @click="gerar_oc()">{{ oc_fornecedor.destino_oc_id ? 'Incluir' : 'Gerar' }}</az-submit>
                    </div>
                </div>
            </div>
        </div>

        <!-- OCs Geradas -->
        <div class="modal fade" id="ocsModal" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
            <div class="modal-dialog modal-dialog-total modal-dialog-scrollable" role="document">
                <div class="modal-content modal-content-total">
                    <div class="modal-header">
                        <h5 class="modal-title">{{ aqocs && aqocs.ocs && aqocs.ocs.length > 1 ? 'Ordens de Compra' : 'Ordem de Compra' }}</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <template v-if="!aqocs">
                            <az-empty-state />
                        </template>

                        <template v-else-if="!oc_selecionada">
                            <ul class="list-group">
                                <li class="list-group-item" v-for="(oc, iox) in aqocs.ocs" :key="iox">
                                    <div class="d-flex justify-content-between">
                                        <a href="#" @click.prevent="selecionar_oc(oc)" class="card-link">
                                            #{{ oc.id_aquisicao_ordem_compra }}
                                            <i class="fa fa-caret-right mx-2" aria-hidden="true"></i>
                                            {{ $util.getFormatDate(oc.created_at) }}
                                            <i class="fa fa-caret-right mx-2" aria-hidden="true"></i>
                                            {{ oc.fornecedor.search }}
                                            <span class="badge badge-secondary ml-2">
                                                {{ oc.items.length }}
                                            </span>
                                            <div :class="'ml-2 badge badge-' + oc.status_aprovacao.color">
                                                {{ oc.status_aprovacao.title }}
                                            </div>
                                        </a>
                                        <div>
                                            <button type="button" class="btn btn-primary btn-sm" @click="oc.fl_ativo = !oc.fl_ativo">
                                                <i class="fas fa-copy"></i>
                                            </button>
                                        </div>
                                    </div>
                                    <div v-if="!oc.fl_ativo" class="mt-3">
                                        <az-input
                                            sizing="sm"
                                            type="label"
                                            icon="fas fa-copy"
                                            v-if="oc.copiar_para"
                                            :label="oc.copiar_para.search"
                                            placeholder="Copiar Ordem de Compra para o Fornecedor...">
                                            <template v-slot:buttonposb>
                                                <div class="input-group-append" v-if="oc.copiar_para">
                                                    <button class="btn btn-outline-danger" type="button" id="button-addon2" @click="oc.copiar_para = null; $forceUpdate()">
                                                        <i class="fa fa-times" aria-hidden="true"></i>
                                                    </button>
                                                    <az-submit color="outline-success" @click="copiar_oc(oc)">
                                                        <i class="fa fa-check" aria-hidden="true"></i>
                                                    </az-submit>
                                                </div>
                                            </template>
                                        </az-input>

                                        <selecao-fornecedor 
                                            v-else
                                            icon="fas fa-copy"
                                            placeholder="Copiar Ordem de Compra para o Fornecedor..."
                                            @selecionado="copiar_para_fornecedor(oc, $event)" />
                                    </div>
                                </li>
                            </ul>

                            <br><br><br><br><br><br><br><br><br><br>
                        </template>

                        <template v-else>
                            <ordem-de-compra-detalhe :oc_selecionada="oc_selecionada" modal="ordemModal" @refresh="load()" />
                        </template>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Fechar</button>
                        <az-submit v-if="oc_selecionada && oc_selecionada.fl_autorizado === false && !oc_selecionada.id_usuario_aut" @click="resolicitar_aut()">
                            Resolicitar Autorização
                        </az-submit>
                    </div>
                </div>
            </div>
        </div>

        <share-solic-cotacao ref="sharecot" />
        <log-integracao ref="logint" />

    </div>
</template>

<script>
import _ from 'lodash';
import $ from 'jquery';
import AzInput from '../../shared/forms/AzInput.vue';
import AzEmptyState from '../../util/AzEmptyState.vue';
import AzSubmit from '../../util/AzSubmit.vue';
import AzPeriodo from '../../shared/forms/AzPeriodo.vue';
import SelecaoMaterial from './SelecaoMaterial.vue';
import SelecaoFornecedor from './SelecaoFornecedor.vue';
import CabecalhoGenerico from '../../relatorios/shared/CabecalhoGenerico.vue';
import MapaDeCotacao from './MapaDeCotacao.vue';
import PrintExport from '../../shared/PrintExport.vue';
import OrdemDeCompraDetalhe from './OrdemDeCompraDetalhe.vue';
import ShareSolicCotacao from './ShareSolicCotacao.vue';
import AzAuditLogButton from '../../util/AzAuditLogButton.vue';
import LogIntegracao from '../../shared/audit/LogIntegracao.vue';

export default {
    data() { 
        return { 
            search: "",
            viewMode: "S", 
            dados: [],
            firstload: false,
            montando: true, 
            filtros: { 
                inicio: this.$util.hoje(),
                fim: this.$util.hoje(),           
                id_unidade_operacao: "", 
                periodo: "s",
                id_estoque_tipo_movimentacao: "", 
                tipo_data: "", 
                status_aquisicao: "", 
            },
            item: null, 
            aqp: null, 
            validate: false, 
            preco_fornecedor: "", 
            precos: null, 
            trocando: false, 
            tabela: null,
            oc_fornecedores: null, 
            oc_fornecedor: null, 
            aqocs: null, 
            oc_selecionada: null, 
            condicoes: null, 
            options_classes: null, 
        }
    },

    components: { 
        AzInput,
        AzEmptyState,
        AzPeriodo, 
        SelecaoMaterial, 
        SelecaoFornecedor, 
        AzSubmit, 
        CabecalhoGenerico, 
        MapaDeCotacao, 
        PrintExport,
        OrdemDeCompraDetalhe, 
        ShareSolicCotacao, 
        AzAuditLogButton,
        LogIntegracao, 
    },

    props: ['id'], 

    computed: { 
        ocs_para_adicao: function () { 

            if ( !this.oc_fornecedores || !this.oc_fornecedores.ocs || !this.oc_fornecedor ) { 
                return [];
            }

            return this.oc_fornecedores.ocs.filter(oc => oc.id_fornecedor == this.oc_fornecedor.id_fornecedor && ( oc.status_aprovacao.cod == 'X' || oc.status_aprovacao.cod == 'E'))
                .map(oc => { 
                    return { 
                        id: oc.id_aquisicao_ordem_compra, 
                        search: 'OC #' + oc.id_aquisicao_ordem_compra + ' / ' + oc.status_aprovacao.title, 
                    }
                });

        },

        lista: function () { 
            if ( !this.dados )
                return [];

            if ( this.filtros.search ) { 
                let reg = this.$util.getregex(this.filtros.search);
                return this.dados.filter(item => reg.test(JSON.stringify(item)));
            }

            return this.dados;
        },
    },

    methods: { 
        clonar (com_cotacoes = false) { 
            if ( !confirm ('Confirma clonar o processo ' + ( com_cotacoes ? '(com cotações)' : '(sem cotações)' ) + '?') )
                return;

            this.$util.atualizar(this, { 
                service: 'aquisicao',
                func: 'clonar',
                dados: { 
                    id_aquisicao: this.item.id_aquisicao, 
                    com_cotacoes: com_cotacoes,
                }, 
                modal: 'modal', 
                reload: true, 
            });
        },

        resolicitar_aut () { 
            this.$util.atualizar (this, { 
                service: 'aquisicao_ordem_compras',
                func: 'resolicitar_autorizacao',
                dados: { 
                    id_aquisicao_ordem_compra: this.oc_selecionada.id_aquisicao_ordem_compra
                },
                modal: 'ocsModal',
                toast: true, 
                reload: true, 
            });
        },

        pode_editar_preco (item) { 
            console.log('pode', item);
            if ( item.oc_item ) { 
                console.log('111');
                if ( item.oc_item.oc && item.oc_item.oc.fl_autorizado === false && !item.oc_item.oc.id_usuario_aut ) { 
                    console.log('222');
                    return true;
                } 

                return false;
            } 

            return true; 
        },

        ver_log_int (aqs) { 
            this.$refs.logint.abrir('App\\azure\\aquisicao', aqs.id_aquisicao, true);
        },

        editar_condicoes (ocf) { 
            $('.modal').modal('hide');

            console.log('ocf', ocf);

            this.editar_precos(ocf);
        },

        incluir_item_servico () { 
            this.item.items.push({ 
                st_tipo: 'S', 
                fl_ativo: 1, 
                dc_quantidade: 1, 
                st_observacao: "", 
                st_descricao: "", 
            });
        },

        copiar_oc (oc) { 
            this.$util.atualizar(this, { 
                service: 'aquisicao',
                func: 'copiar_oc',
                dados: oc, 
                modal: 'ocsModal', 
                reload: true, 
                toast: true, 
            });
        },

        copiar_para_fornecedor (oc, fornecedor) { 
            oc.copiar_para = fornecedor;
            this.$forceUpdate();
        },

        share (aqs) { 
            this.$refs.sharecot.abrir(aqs);
        },

        remover_item (preco, idx) { 
            preco.js_condicoes_pagamento.parcelas.splice(idx, 1);
        },

        mostrar_detalhe_condicoes (info) {
            this.condicoes = info;

            $('#condicoesModal').modal('show');
        },

        fechar(modal) { 
            $('#' + modal).modal('hide');
        },

        remover_oc() { 
            if ( !confirm('Confirma remover a ordem de compra?') )
                return;

            this.$util.atualizar(this, { 
                service: 'aquisicao_ordem_compras',
                func: 'remover_oc',
                dados: { 
                    id: this.oc_selecionada.id_aquisicao_ordem_compra,
                },
                modal: 'ocsModal', 
                reload: true, 
            });
        },

        imprimir_oc () { 
            this.$util.print_preview('imprimir/oc/' + this.oc_selecionada.id_aquisicao_ordem_compra, true);
        },

        enviar_oc_por_email () { 
            console.log(this.oc_selecionada);
            alert('Em desenvolvimento...');
        },

        selecionar_oc (oc) { 
            this.oc_selecionada = _.cloneDeep(oc);
        },

        view_ocs (aqs) { 
            this.aqocs = null;
            this.oc_selecionada = "";
            this.validate = false;

            this.$nextTick(() => { 
                this.$store.commit('loading', true);

                this.$util.loadItem(this, { 
                    service: 'aquisicao',
                    parms: { 
                        id: aqs.id_aquisicao, 
                        ocs: true, 
                    },
                })
                .then(res => { 
                    this.aqocs = res;
                })
                .finally(() => { 
                    this.$store.commit('loading', false);
                });

                $('#ocsModal').modal('show');
            });
        },

        gerar_oc () { 
            this.$util.atualizar(this, { 
                service: 'aquisicao',
                func: 'gerar_oc',
                dados: this.oc_fornecedor, 
                modal: 'ordemModal',
                reload: true, 
            });
        },

        ordem_de_compra (item) { 
            this.oc_fornecedores = null;
            this.oc_fornecedor = "";
            this.validate = false;

            this.$nextTick(() => { 
                this.$store.commit('loading', true);

                this.$util.loadItem(this, { 
                    service: 'aquisicao',
                    parms: { 
                        id: item.id_aquisicao, 
                        oc: true, 
                    },
                })
                .then(res => { 
                    if ( res && res.fornecedores ) { 
                        res.fornecedores.forEach(item => { 
                            item.destino_oc_id = "";
                            return item;
                        });
                    }

                    this.oc_fornecedores = res;

                    if ( item.id_fornecedor ) { 

                        let teste = this.oc_fornecedores.fornecedores.map(fornec => { 
                            fornec.search = fornec.fornecedor.search;
                            return fornec;
                        })
                        .find(fornec => fornec.id_fornecedor == item.id_fornecedor);

                        if ( teste ) { 
                            this.oc_fornecedor = teste;
                        }

                    }
                })
                .finally(() => { 
                    this.$store.commit('loading', false);
                });

                $('#ordemModal').modal('show');
            });
        },

        atualizar_selecao () { 
            this.$util.atualizar(this, { 
                service: 'aquisicao',
                func: 'atualizar_selecao',
                dados: this.tabela, 
                modal: 'tabelaModal',
                reload: true, 
            });
        },

        selecionar_preco(id, precos) { 
            let preco = precos.find(item => item.id_aquisicao_item == id);
            
            if ( preco ) { 
                preco.fl_selecionado = !preco.fl_selecionado;
            }
        },

        totalizar_precos (fornec, selec = false) { 
            return fornec.precos.filter(preco => !selec || preco.fl_selecionado)
                .reduce((total, carry) => total + ( parseFloat(carry.dc_preco) * parseFloat(carry.dc_quantidade) ), 0);
        },

        totalizar_lista_precos (precos) { 
            return precos.reduce((total, carry) => total + ( ( parseFloat(carry.dc_preco) + parseFloat(carry.dc_ipi) ) * parseFloat(carry.dc_quantidade) ), 0);
        },

        obter_preco(id, precos, campo, format = null) { 
            let preco = precos.find(item => item.id_aquisicao_item == id);
            
            if ( preco ) { 
                let valor;

                switch (campo) {
                    case 'total':
                        valor = _.get(preco, 'dc_preco') * _.get(preco, 'dc_quantidade');
                        break;
                
                    default:
                        valor = _.get(preco, campo);
                        break;
                }

                switch (format) {
                    case 'M':
                        valor = valor > 0 ? this.$util.formatMoeda(valor) : null;       
                        break;

                    case 'Q':
                        valor = valor > 0 ? this.$util.formatNumber(valor, 0) : null;       
                        break;
                
                    default:
                        break;
                }

                return valor;
            }
                
        },

        comparacao(item) { 
            this.tabela = null;
            this.validate = false;

            this.$store.commit('loading', true);

            this.$util.loadItem(this, { 
                service: 'aquisicao',
                parms: { 
                    id: item.id_aquisicao, 
                    id_estoque_grupo_local: item.id_estoque_grupo_local, 
                    preco: true, 
                },
            })
            .then(res => { 
                this.tabela = res;
            })
            .finally(() => { 
                this.$store.commit('loading', false);
            });

            $('#tabelaModal').modal('show');
        },

        incluir_parcela() { 

            if ( !this.preco_fornecedor.js_condicoes_pagamento ) { 
                this.preco_fornecedor.js_condicoes_pagamento = {
                    parcelas: [],
                };
            }

            if ( !this.preco_fornecedor.js_condicoes_pagamento.parcelas ) { 
                this.preco_fornecedor.js_condicoes_pagamento.parcelas = [];
            }

            this.preco_fornecedor.js_condicoes_pagamento.parcelas.push({
                regra: 'P', 
                modo_tempo: 'T',
                tempo_dias: "", 
                tempo_data: "", 
                modo_valor: 'P', 
                valor: 0, 
            });

            this.$forceUpdate();

        },

        trocar() { 
            this.trocando = true;

            this.$nextTick(() => { 
                /*
                if ( this.preco_fornecedor && !this.preco_fornecedor.js_condicoes_pagamento ) { 
                    this.preco_fornecedor.js_condicoes_pagamento = {
                        tem_adiantamento: false, 
                    };
                }
                */

                this.trocando = false;
            });
        },

        atualizar_precos() { 
            this.$util.atualizar(this, { 
                service: 'aquisicao',
                func: 'atualizar_precos',
                dados: this.precos, 
                modal: 'precosModal', 
                reload: true, 
                callback: () => { 
                    console.log('callback', this.aqp);
                    if ( this.aqp.id_aquisicao_fornecedor ) { 
                        this.ordem_de_compra(this.aqp);
                    }
                }
            });
        },

        editar_precos(item) { 
            this.aqp = _.cloneDeep(item);
            this.preco_fornecedor = "";
            this.precos = null; 
            this.validate = false;

            this.$store.commit('loading', true);

            this.$util.loadItem(this, { 
                service: 'aquisicao',
                parms: { 
                    id: item.id_aquisicao, 
                    preco: true, 
                },
            })
            .then(res => { 
                this.precos = res;

                if ( item.id_fornecedor ) { 
                    let teste = this.precos.fornecedores.map(fornec => { 
                        fornec.search = fornec.fornecedor.search;
                        return fornec;
                    })
                    .find(fornec => fornec.id_fornecedor == item.id_fornecedor);

                    if ( teste ) { 
                        this.preco_fornecedor = teste;
                    }
                                
                }
            })
            .finally(() => { 
                this.$store.commit('loading', false);
            });

            $('#precosModal').modal('show');
        },

        lista_ativos(lista) { 
            return lista.filter(item => item.fl_ativo);
        },

        remover(item) { 
            item.fl_ativo = false;
        },

        load() { 
            if ( this.montando )
                return;

            this.$util.load(this, { 
                service: 'aquisicao',
                parms: { 
                    ...this.filtros, 
                    lista: true, 
                }
            });
        },

        buscar_tags_fornecedor () { 
            if ( this.options_classes ) 
                return;

            this.$util.loadItem(this, { 
                service: 'fornecedores',
                func: 'tags',
                parms: { 
                    aquisicao: true, 
                }
            })
            .then(res => { 
                this.options_classes = res;
            });
        },


        editar (aqs) { 
            this.buscar_tags_fornecedor();

            this.item = null; 
            this.validate = false; 

            this.$nextTick(() => { 
                this.item = _.cloneDeep(aqs);

                $('#aquisicaoModal').modal('show');
            });
        },

        incluir() { 
            this.buscar_tags_fornecedor();

            this.item = null; 
            this.validate = false; 

            this.$nextTick(() => { 
                this.item = { 
                    id_aquisicao: null, 
                    st_tipo: 'M', 
                    id_unidade_operacao: "", 
                    dt_fim_processo: "", 
                    fl_ativo: true, 
                    items: [], 
                    fornecedores: [], 
                };

                $('#aquisicaoModal').modal('show');
            });
        },

        incluir_item(novo) { 
            if ( !novo )
                return;

            let qtd;
            let fator;
            let unidade;

            if ( novo.st_unidade_compra && novo.st_unidade_compra != novo.st_unidade_estoque ) { 
                qtd = novo.quantidade_compra;
                fator = novo.quantidade;
                unidade = novo.st_unidade_compra;
            } else { 
                qtd = novo.quantidade;
                fator = 1;
                unidade = novo.st_unidade_estoque;
            }

            this.item.items.push({
                estoque_item: novo, 
                id_estoque_item: novo.id_estoque_item, 
                fl_ativo: true, 
                st_tipo: this.item.st_tipo, 
                st_descricao: "", 
                st_unidade: unidade,
                st_observacao: "", 
                dc_quantidade: qtd,
                in_fator: fator, 
            });
        },

        incluir_fornecedor(novo) { 
            if ( !novo )
                return;

            if ( this.item.fornecedores.find(fornec => fornec.id_fornecedor == novo.id_fornecedor && fornec.fl_ativo) ) { 
                this.$toast.add({
                    severity: "warn",
                    summary: "Atenção",
                    detail: "Fornecedor já selecionado.",
                    life: 3000
                });
                return;
            }

            this.item.fornecedores.push({
                id_fornecedor: novo.id_fornecedor, 
                fl_ativo: true, 
                fl_pendente: true, 
                fornecedor: novo, 
                st_observacao: "", 
            });
        },

        atualizar() { 
            this.$util.atualizar(this, { 
                service: 'aquisicao',
                dados: this.item, 
                modal: 'aquisicaoModal',
                reload: true, 
                toast: true, 
            });
        },

        imprimir_cotacao (af) { 
            this.$util.print_preview('imprimir/cotacao/' + af.id_aquisicao_fornecedor, true);
        },

    },

    beforeMount() { 
        if ( this.id && !isNaN(this.id) ) { 
            this.filtros.search = '#' + this.id;
        }
    },

    mounted() { 
        this.$store.commit("setBreadcrumb", [
            { name: "Suprimentos", path: "/suprimentos" },
            { name: "Aquisição", path: "/suprimentos/aquisicao" }
        ]);

        /*
        this.$util.loadItem(this, { 
            service: 'usuarios',
            func: 'tem_permissao_acesso', 
            parms: { 
                resource_id: 17 
            }
        })
        .then(res => { 
            this.autorizador = res.pode;
        });
        */

        this.$nextTick(() => { 
            this.montando = false;
            this.load();
        });
    }
}
</script>

<style scoped>
.modal-dialog-total {
  top: 0;
  width: 100% !important;
  height: 100% !important;
  padding: 0 !important;
  max-width: 100% !important;
  max-height: 100% !important;
  margin-top: 0px;
  margin-bottom: 0px;
  margin: 0px !important;
}

.modal-content-total {
  height: 100% !important;
  max-height: 100% !important;
}
</style>